import { Button, Link } from 'components'
import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

export const PriceCard = ({
  actual_price,
  early_offer,
  to
}: {
  actual_price: number
  early_offer: number
  to: string
}) => {
  return (
    <div className="px-12 py-12 border border-zinc-50/20 rounded-lg text-zinc-50 bg-white/10">
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-3">
          <div className="flex flex-row justify-between gap-10 text-xl">
            <p>Batch starting</p>
            <p className="line-through">₹ {actual_price}/-</p>
          </div>
          <div className="flex flex-row justify-between gap-10 text-xl">
            <p className="font-semibold text-primary">Early birds discount</p>
            <p className="text-[#FFE14D] font-bold">₹ {early_offer}/-</p>
          </div>
        </div>
        <div className="flex flex-col gap-3 items-center">
          <Link href={to}>
            <Button
              size="large"
              rounded="small"
              className="bg-primary hover:bg-primary-dark">
              Apply Now <ArrowRightIcon className="w-5 h-5" />
            </Button>
          </Link>
          <p className="text-lg">EMI options available</p>
        </div>
      </div>
    </div>
  )
}
